<footer class="bg-white border-t border-sp-gray-200 mt-auto">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 mb-6">
    <div class="text-center text-sm text-sp-gray-600 space-y-3">
      <!-- Copyright -->
      <div class="text-xs sm:text-sm">
        © {{ year }} ScottishPower Energy Retail Limited. All rights reserved.
      </div>

      <!-- Privacy and Terms - Responsive Layout -->
      <div class="flex flex-wrap justify-center items-center gap-x-1 gap-y-2 text-xs sm:text-sm">
        <span>ScottishPower</span>
        <a href="https://www.scottishpower.co.uk/legal/privacy-policy" target="_blank" class="text-sp-link hover:underline whitespace-nowrap font-bold">Privacy Policy</a>
        <span>and</span>
        <a href="https://www.scottishpower.co.uk/legal" target="_blank" class="text-sp-link hover:underline whitespace-nowrap font-bold">Terms of Service</a>
        <span>apply.</span>
        <span>Read about how we use</span>
        <a href="/cookies" class="text-sp-link hover:underline whitespace-nowrap font-bold">Cookies.</a>
      </div>
    </div>
  </div>
</footer>